import styled from 'styled-components';
import ds from 'designsystem';

import PanelGroup from 'blocks/PanelGroup/index';

/* Disable ESlint rules for this file */
/* eslint no-confusing-arrow: "off" */
/* eslint react/destructuring-assignment: "off" */

const StyledPanelTitle = styled(PanelGroup.Title)`
margin-bottom: 0;
width:100%;
position: relative;
& a {
    color: ${props => props.isActive ? ds.brand('product') : ds.brand('text')};
    font-size: 90px;
    display:block;
    width:100%;
    height:100%;
}
`;

export default StyledPanelTitle;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Accordion/PanelGroup/StyledPanelTitle.jsx